import { PRODUCT_ACTIONS, PRODUCTS_VIEW } from '../utils/products';

export interface IAuthors {
    readonly about: string;
    readonly author_id: number;
    readonly name: string;
    readonly photo: string;
    readonly user_id: number;
}

export interface IProducts {
    id?: number;
    readonly shop_id?: number;
    readonly title: string;
    readonly description: null | string;
    readonly images: [] | string | File | null;
    readonly price: number;
    readonly old_price: number | null;
    readonly buyable: boolean;
    readonly categories?: ProductCategory[];
    category_ids?: number[];
    readonly status: ProductStatus;
    readonly link?: null | string;
    readonly type?: ProductsTypes;
    readonly external_code?: null | number;
    image_urls?: string[];
}

export interface ProductProps {
    readonly shop_id?: number;
    readonly description: string | null;
    readonly id: number;
    readonly images: Array<{ id: number; file: string }>;
    readonly title: string;
    readonly buyable: boolean;
    readonly price?: string;
    readonly old_price?: number | null;
    readonly product_id?: number;
    readonly status: ProductStatus;
    readonly category_name: string;
    readonly link?: null | string;
    readonly type?: ProductsTypes;
}

export interface IProductsPublic<T> {
    readonly items: Array<T>;
    readonly total: number;
}

export interface IProductFilters {
    id?: number;
    limit: number;
    offset: number;
    title?: string;
}

export enum ProductsTypes {
    product = 'product',
    link = 'link',
    productOrder = 'offer',
}

export interface ProductsFilters {
    shop_id?: number;
    offset: number;
    limit: number;
    page: number;

    title?: string;
    category_id?: number | null;
    status?: Array<number>;
    type?: ProductsTypes;
}

export enum ProductsLisType {
    active = 'active',
    archive = 'archive',
    disabled = 'disabled',
}

export enum ProductStatus {
    active = 1,
    archived = 2,
    disabled = 3,
}

export interface ProductBuy {
    readonly telegram_user_id: string | number;
    readonly product_id: number;
    readonly address: string;
    readonly email: string;

    phone?: string;
    first_name?: string;
    last_name?: string;
    username?: string;
    is_mobile?: boolean;
}

export interface ProductPay {
    redirect?: string;
    order_id?: number;
}

export interface CategoryPositionProps {
    parent_id: number;
    category_id: number;
    position: number;
}

export interface ProductCategory {
    id: number;
    name: string;
    shop_id: number;
    parent_id: number;
}

export interface ProductListProps {
    readonly list: {
        items: ProductProps[];
        total: number;
    };
    readonly pagination: any;
    readonly isLoading: boolean;
    readonly updateFilters?: (filters: any) => void;
    readonly filters?: any;
    rowSelection?: any;
    isMultipleActionsAvailable?: boolean;
}

export type ProductsViewType =
    (typeof PRODUCTS_VIEW)[keyof typeof PRODUCTS_VIEW];

export type ProductActionList =
    (typeof PRODUCT_ACTIONS)[keyof typeof PRODUCT_ACTIONS];
